// ThirdEye admin API — this site has no .env, so the values are fixed here.
//export const API_BASE_URL = 'https://admin.3i.lts251.com';
export const API_BASE_URL = 'https://admin.thirdeyecybersecurity.com';
export const COMPANY_PID = '9bacmw77';
